<template>
  <div class="error-page">
    <img src="/static/login/logo.png" height="80" />
    <p class="error-code" style="font-size: 40px;font-weight: bolder;margin: 30px">404 : Page Not Found</p>
    <a href="/#/login" target="_parent" title="点击此处回到登录页面" style="font-size: 30px;color:#2258cc;margin-top: 30px">点击此处回到登录页面</a>
  </div>
</template>

<script>
export default {
  name: 'error-page',
};
</script>

<style lang="scss">
.error-page {
  height: 60%;
  display: -webkit-box;
  -webkit-box-pack:center;
  -webkit-box-align:center;
  -webkit-box-orient: vertical;
  text-align: center
}
</style>



// WEBPACK FOOTER //
// src/views/404.vue